import './notfound.scss';

const NotFound = () => {
  return (
    <div className='notfound'>
      <h1 className='number'>4</h1>
      <h1 className='number'>0</h1>
      <h1 className='number'>4</h1>
    </div>
  );
};

export default NotFound;